// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
//import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Classes
import { FormAction } from "../../shared/classes/formAction";

//Libraries
import { CASValidate } from '../../shared/library/casValidate';
import { BCGrowls } from '../../shared/library/bcGrowls';


//Config/Globals
//import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CappViewComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.capp-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.capp-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.capp-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.capp-legend-item-div{margin:0 16px 0 2px}.capp-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.capp-control-lbl{margin-right:4px}.capp-filter-radio{padding-left:10px;display:flex;align-items:center}.capp-main-control-break{flex-basis:100%;height:0}.capp-cssClasses_Grid{border-top:solid 1px #bbb}.capp-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.capp-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.capp-cssClasses_EditableCell_complete{border:solid 1px green !important}'],
    template : '<!--Content Div-->\n<div class="capp-main-content-div" data-test-id="content_capp_view">\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Title -->\n    <!-- ---------------------------------------------------- -->\n    <!--NOTE: Need to rework this this if you add more forms-->\n    <h2 tabindex="-1" class="cpd-title-div">CAPP - View Points</h2>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER (hidden during loading operations)-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Control Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-control-div">\n\n            <!--Top Control Bar-->\n            <div class="cpd-control-unit">\n\n                <label class="capp-control-lbl" style="font-weight:bold;">Fiscal Year:</label>\n                <div style="padding-right:10px; border-right:solid 1px #ccc;">{{_paramFY}}</div>\n\n                <label style="padding-left:10px; font-weight:bold;" class="capp-control-lbl">Asset:</label>\n                <div style="padding-right:10px; border-right:solid 1px #ccc;">{{_practiceDisplay}}</div>\n\n                <label style="padding-left:10px; font-weight:bold;" class="capp-control-lbl">Narrative Code:</label>\n                <div style="padding-right:10px; border-right:solid 0px #ccc;">{{_narrative?.practice_narrative_code}}</div>\n\n            </div>\n\n        </div>\n\n        <!--Second Control Bar-->\n        <div class="capp-main-control-div">\n            <div id="divNarrativeDescription" style="padding:4px; width:100%;" aria-label="Asset Narrative Description">\n                <span class="fake-anchor"\n                      style="font-weight:bold; "\n                      (click)="textToggleClicked()"\n                      title="Click to toggle full text display.">\n                    Narrative Text:\n                </span>\n\n                <!--Full Text Displayed-->\n                <!--Do not put a carriage return bewteen the tag start and the content in the markup below. The "pre" style will\n                    read that if you do and insert it into your content.  However, that style is the only easy way to get the browser\n                    to not collapse white space (including carriage returns).-->\n                <div *ngIf="_narrativeShowFullText == true" style="width:100%; white-space:pre-wrap;">{{getNarrativeTextFromNarrative(_narrative)}}</div>\n\n                <!--Truncated Text Displayed-->\n                <div *ngIf="_narrativeShowFullText == false">{{getNarrativeTextFromNarrative(_narrative)}}</div>\n\n            </div>\n        </div>\n\n        <!--Third Control Bar-->\n        <div class="capp-filter-control-div">\n\n            <!--swapa category selection-->\n            <div class="cpd-control-unit" style="margin-right:30px;">\n                <label for="selSwapa" class="cpd-ui-field-div-lbl">SWAPAE+H Category:</label>\n                <select id="selSwapa" [disabled]="_disableControls" [(ngModel)]="_selectedSwapaCategory" (change)="swapaChanged()">\n                    <option *ngFor="let swapa of _swapaCategories;" [ngValue]="swapa">{{swapa.swapa_category_name}}</option>\n                </select>\n            </div>\n\n        </div>\n        \n\n        <!-- ---------------------------------------------------- -->\n        <!-- Grid Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-grid-div">\n            <cas-grid #mainGrid\n                      summary="CAPP - View Points"\n                      [settings]="_mainGridSettings"\n                      (onRefreshClicked)="gridRefreshClicked()">\n            </cas-grid>\n            <!--(onValidationFailed)="gridValidationFailed($event)"-->\n        </div>\n\n    </ng-container>\n\n</div>\n',
    providers:[],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class CappViewComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('mainGrid') mainGrid;
    
    //Class wide member reference for the growls control
    growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'cappView.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'capp_view'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    //_formData = null;             //List of forms data for capp edit

    //UI Indicators

    //Data
    _allComponents = null;
    _allLandUses = null;
    _narrative = null;
    _narrativeShowFullText = false;
    _paramFY = null;                    //From route
    _paramPracticeStateId = null;       //From route
    _pointsDTO = null;                  //Stores the last practice points DTO pulled down from the server in case we ever want to edit this before sending it back to the server for saves.
    _pointsHash = null;                 //Created from dto when points are loaded, used as a lookup to help create the grid array
    _practiceDisplay = "";

    _swapaCategories = [];
    _selectedSwapaCategory = null;

    //Main Grid
    _mainGridSettings = {
        blankCellValue:"--",
        disableSelection: true,
        hideClearSelectedButton: true,
        hidePaginationControls: false,
        positionAbsolute: true,
        rows: [],
        rowsPerPage: 25,
        showCheckboxColumn: true,    //Required for rowIdentifyForJAWS (to meet 508 requirements)
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "resource_concern_component_display",
        rowIdentityPrefixForJAWS: "Component", 
        columns: []
    };


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        activeRoute: ActivatedRoute,
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        //formDataService: FormDataService2,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        // Growl Prep
        //--------------------
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({ 
	        appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        }); 

        //Actions
        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Validation
        //--------------
        this.casValidate = new CASValidate();

        // Debugging 
        //--------------
        casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Dump DTO");
        //casNavBoxService.DebugEntries.push("Dump Rows");
        //casNavBoxService.DebugEntries.push("Clear Sort");

        disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
            this.debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        this.markGridAsLoading(true);

        //Grab the route parameters
        this._paramFY = this.activeRoute.snapshot.params.fy;
        this._paramPracticeStateId = this.activeRoute.snapshot.params.practiceStateId;
        this._paramNarrativeId = this.activeRoute.snapshot.params.narrativeId;

        this.casNavBoxService.DisableAllLinks();
        this._disableControls = true;
        this.casNavBoxService.ActionsLoading = true;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        //Async ops
        let ops = 5;

        //FORMS
        //  Currently, only one role can access this screen (CAPP Steward), so there's no need to evaluate roles for these action links
        let actions = [];
        actions.push(new FormAction("act_back", "Back to Narratives"));
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

        //Load - practice info for the displayed practice state id (OP-1)
        this.loadPracticeState(this._paramPracticeStateId, (dto)=>{
            this._practiceDisplay = dto.practice_code + " - " + dto.practice_name.substr(0,50);
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //Load - Narrative (OP-2)
        this.loadPracticeNarrative(this._paramNarrativeId, (dto) => {
            this._narrative = dto;
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //Load - Land Uses (OP-3)
        this.loadLandUses(this._paramFY, (dto)=>{
            this._allLandUses = dto;
            this.setGridColumns();
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //Load - All Resource Concern Components (OP-4)
        this.loadComponents(this._paramFY, (dto)=>{
            this._allComponents = this.flattenRCC_DTO(dto);
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //Load - SWAPA categories.  We need this before we load the points. (OP-5)
        this.loadSwapaCategories((dto) => {

            //Store the categories
            this._swapaCategories = [{
                swapa_category_id: null,
                swapa_category_name: "All"
            }].concat(dto);
            
            //Select the first one
            this._selectedSwapaCategory = this._swapaCategories[0];

            //Load - Points for this narrative
            this.loadPracticePoints(
                this._paramFY, 
                this._paramNarrativeId,
                (dto, hash)=>{
                    this._pointsDTO = dto;
                    this._pointsHash = hash;
                    if (--ops == 0) { this.ngOnInit_Complete(); }
                }
            );


        });

    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        //Init the validation class
        //this.casValidate.initialize(true);
        this.buildGridData(() => {
            this.casNavBoxService.EnableAllLinks();
            this._disableControls = false;
            this.casNavBoxService.ActionsLoading = false;
            this._pageLoading = false;
            this.markGridAsLoading(false);
            console.log("ngOnInit_Complete()");

            //var hash = this._pointsHash;
            //var dto = this._pointsDTO;
        });

    };


    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        switch (action.field_name.toLowerCase()) {
            case "act_back":
                let route = "/cpdes/capp/dashboard/{0}/{1}".format(this._paramFY, this._paramPracticeStateId);
                this.router.navigate([route]);
                break;
        }

    };


    // UI - METHODS & EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // getNarrativeTextFromNarrative
    //==================================
    getNarrativeTextFromNarrative(narrative) {
        if (!narrative) { return ""; }
        
        return this._narrativeShowFullText ? 
            narrative.practice_narrative : 
            this.helpers.truncateString(narrative.practice_narrative, 300);
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked(fnOnComplete) {

        //this._pointsDTO = [];
        //this._pointsHash = {};

        this.markGridAsLoading(true);

        this.loadPracticePoints(
            this._paramFY, 
            this._paramNarrativeId, 
            (dto, hash)=>{

                this._pointsDTO = dto;
                this._pointsHash = hash;
        
                //Help IE not lock up
                this.buildGridData(() => {
                    this.markGridAsLoading(false);

                    //BuildGridData calls SetRowsAsync on the grid,which will clear any filters.  Add it back.
                    this.swapaChanged();

                    if (fnOnComplete) { fnOnComplete(); }
                });
            }
        );
    }

    //==================================
    // gridValidationFailed
    //==================================
    //gridValidationFailed(message){
    //    console.log("[{0}:gridValidationFailed()]".format(this._componentName), message);
    //}

    //=======================================
    // markGridAsLoading
    //=======================================
    markGridAsLoading(isLoading) {

        if (this.mainGrid) {
            this.mainGrid.MarkAsLoading(isLoading);
        }
        else {
            this._mainGridSettings.loading = isLoading;
        }
    }

    //=======================================
    // swapaChanged
    //=======================================
    swapaChanged() {

        //Filter the grid locally
        this.mainGrid.ClearFilters();

        if (this._selectedSwapaCategory.swapa_category_id) {
            this.mainGrid.SetFilter(
                "swapa", 
                (row)=>{ return row.swapa_category_id == this._selectedSwapaCategory.swapa_category_id; },
                true
            );
        }
    }

    //=======================================
    // textToggleClicked
    //=======================================
    textToggleClicked() {
        this._narrativeShowFullText = !this._narrativeShowFullText;
    }

    // BUSINESS LOGIC & NON-UI EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // buildGridData
    //=======================================
    buildGridData(fnOnComplete){

        let rows = [];

        //Cycle through the components
        for (let i=0; i<this._allComponents.length; i++){

            //console.log("   Processing Component:", i);

            let component = this._allComponents[i];

            //Add the concern and component data to this row
            let row = {
               resource_concern_display:component.resource_concern_display,         //+ "(" + component.resource_concern_component_id + ")"
               resource_concern_component_display:component.resource_concern_component_display,
               swapa_category_id:component.swapa_category_id
            }

            //Cycle through the land uses for this component
            for (let j=0; j<this._allLandUses.length; j++){

                let landUse = this._allLandUses[j];

                //Are there any score records for this component?
                if (!this._pointsHash[component.resource_concern_component_id]){ 
                
                    //Record entry missing (no points for any land use), add it to the DTO
                    //this._pointsDTO.points[component.resource_concern_component_id] = {};

                    //Create the hash object for the new DTO record
                    this._pointsHash[component.resource_concern_component_id] = {};

                }

                //Is there a score for this component and land use?
                if (!this._pointsHash[component.resource_concern_component_id][landUse.land_use_id]){ 
                    
                    //No score for this land use, add one with default data
                    let pointRecord = {
                        changed:false,
                        land_use_id:landUse.land_use_id,
                        practice_assessment_points:null,
                        practice_assessment_points_id:null, //Server will not save blank records with no id
                        resource_concern_component_id:component.resource_concern_component_id
                    }
                    this._pointsDTO.points.push(pointRecord);

                    //Create the hash reference to the new land use entry in the DTO
                    this._pointsHash[component.resource_concern_component_id][landUse.land_use_id] = pointRecord;
                }

                //Add the score for this component/landuse
                try{
                    //I want to modify the DTO directly by reference so I can just send it back up to the save method later.
                    //So, we'll use the point record object as the value here and then use the procDataFn and editDataFn methods 
                    //(on the column definitions) to handle the translations on render and edit.
                    row[landUse.land_use_name] = this._pointsHash[component.resource_concern_component_id][landUse.land_use_id];
                }
                catch(err){
                    //Prevent the catch from happeniong in the try/catch for the service call.
                    console.log(err);
                    return;
                }
            }
    
            //Put this row into the rows collection
            rows.push(row);
        }


        //Assign the rows data to the main grid 
        if (this.mainGrid){
            //this.mainGrid.SetRows(rows); //Also clears the sort caret
            this.mainGrid.SetRowsAsync(rows, () => {
                this.mainGrid.SortGrid("resource_concern_component_display", "A", () => {
                    if (fnOnComplete) { fnOnComplete(); }
                });
            });
        }
        else{
            this._mainGridSettings.rows = rows;
            if (fnOnComplete) { fnOnComplete(); }
        }

        
    }

    //=======================================
    // createPointsHash
    //=======================================
    // pointsArray<[obj]>       //Array of point object from the server
    //
    createPointsHash(pointsArray){

        /* Create a 2-dimensional reference hash into the DTO to assist in efficiently creating the grid array
        { 
            componentId_1: { 
                landUseId_1: { pointsRecord:<object ref from DTO> },
                landUseId_2: { pointsRecord:<object ref from DTO> },
                ...
            },
            componentId_2: { 
                landUseId_1: { pointsRecord:<object ref from DTO> },
                landUseId_2: { pointsRecord:<object ref from DTO> },
                ...
            },
            ...
        } */

        let hash = {};

        for (let i=0; i<pointsArray.length; i++){
            
            let pointRecord = pointsArray[i];
            let componentId = pointRecord.resource_concern_component_id;
            let landUnitId = pointRecord.land_use_id;

            //If this component is not in the hash yet, add it
            if (!hash[componentId]){
                hash[componentId] = {};
            }

            //Add the record reference by land use
            hash[componentId][landUnitId] = pointRecord;
        }

        return hash;

    }

    //=======================================
    // flattenRCC_DTO
    //=======================================
    // New DTO format for RCC data is bundelled into objects.  The grid cannot read nested properties.  I tried to add that functionality,
    // but the grid relies too heavily on the flat structure.  The show stopper was sections in the markup that adds "working poperties"
    // to an existing field (making it its own object).  So, we'll just flatten the response form the server back to the old format,
    // but with the new land use data.
    flattenRCC_DTO(dto) {

        let arrOut = [];

        for (let i = 0; i < dto.length; i++) {

            let curRow = dto[i];

            let flatRow = {
                resource_concern_component_id: curRow.component.resource_concern_component_id,
                resource_concern_component_name: curRow.component.resource_concern_component_name,
                resource_concern_component_display: curRow.component.resource_concern_component_display,
                resource_concern_component_description: curRow.component.resource_concern_component_description,
                resource_concern_component_objective: curRow.component.resource_concern_component_objective,
                resource_concern_component_start_date: curRow.component.start_date,
                resource_concern_component_end_date: curRow.component.end_date,
                resource_concern_component_publish: curRow.component.publish,

                resource_concern_id: curRow.concern.resource_concern_id,
                resource_concern_name: curRow.concern.resource_concern_name,
                resource_concern_display: curRow.concern.resource_concern_display,
                resource_concern_description: curRow.concern.resource_concern_description,
                resource_concern_start_date: curRow.concern.start_date,
                resource_concern_end_date: curRow.concern.end_date,
                resource_concern_publish: curRow.concern.publish,
                swapa_category_id: curRow.concern.swapa_category_id,

                resource_concern_category_id: curRow.category.resource_concern_category_id,
                resource_concern_category_name: curRow.category.resource_concern_category_name,
                resource_concern_category_display: curRow.category.resource_concern_category_display,

                selected_land_use_ids: {}
            }


            //Add any associated land uses
            if (curRow.land_uses) {
                for (let j = 0; j < curRow.land_uses.length; j++) {
                    let curLandUse = curRow.land_uses[j].landuse;
                    flatRow.selected_land_use_ids[curLandUse.land_use_id] = curLandUse.land_use_id;
                }
            }

            arrOut.push(flatRow);

        }

        console.log("[{0}:flattenRCC_DTO()]:".format(this._componentName), arrOut);

        return arrOut;

    }

    //=======================================
    // loadComponents
    //=======================================
    loadComponents(fy, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getResourceConcernComponents2",
            args: {
                fiscalYear: fy,
                resourceConcernId: null,
                resourceConcernComponentId: null,
                publishedOnly: true,
                filterLandUseByFY: true
            }
        })
        .then(res => {
            console.log("[{0}:loadComponents():getResourceConcernComponents2] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadComponents()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadLandUses
    //=======================================
    loadLandUses(fy, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/landuse/getLandUses",
            args: {
                fy: fy
            }
        })
        .then(res => {

            console.log("[{0}:loadLandUses():getLandUses] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            //Cut out the unused land uses
            let filteredLandUses = dto.filter(lu => {  
                switch(lu.land_use_code.toLowerCase()){
                    case "pr":  //protected
                    case "kw":  //undetermined
                    //case "wa":  //water
                    break;

                    default:
                        return lu;
                }
            });

            try {
                if (fnOnComplete) { fnOnComplete(filteredLandUses); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadLandUses()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadPracticeNarrative
    //=======================================
    loadPracticeNarrative(narrativeId, fnOnComplete, fnOnError) {
        
        this.webServices.Get({
            apiPath: "/narrative/getNarrativeById",
            args: { narrativeId: narrativeId }
        })
        .then(res => {

            let dto = res.data.DTO;
            console.log("[{0}:/narrative/getNarrativeById()] - res:".format(this._componentName), res);

            //Errors in the callback trigger the catch for this service call and populate the alerts with errors the user shouldn't see.  Catch it here instead.
            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadPracticeNarrative()]".format(this._componentName), err);
                return;
            }
                
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
        
    }

    //=======================================
    // loadPracticePoints
    //=======================================
    loadPracticePoints(fy, pnid, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/capp/getNationalPracticePoints",
            args: {
                fiscalYear: fy,
                practiceNarrativeId: pnid,
                publishedOnly:false         //As of now, we are ignoring the publish field on points
            }
        })
        .then(res => {

            let dto = res.data.DTO;

            console.log("[{0}:loadPracticePoints()]".format(this._componentName));
            console.log("    res:".format(this._componentName), res);

            //Create the reference hash to aid in creating the grid array
            let hashPoints = this.createPointsHash(dto.points);

            console.log("    hash:".format(this._componentName), hashPoints);

            //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
            try {
                if (fnOnComplete) { fnOnComplete(dto, hashPoints); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadPracticePoints()]".format(this._componentName), err);
                return;
            }
                
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadPracticeState
    //=======================================
    loadPracticeState(practiceStateId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeState",
            args: {
                practiceStateId: practiceStateId
            }
        })
        .then(res => {

            console.log("[{0}:loadPracticeState():getPracticeState] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:getPracticeState()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadSwapaCategories
    //=======================================
    loadSwapaCategories(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getSwapaCategories",
            args: {
                fiscalYear: this._paramFY,
                publishedOnly: true
            }
        })
        .then(res => {
            console.log("[{0}:loadSwapaCategories():/resource/getSwapaCategories] - res:".format(this._componentName), res);
            if (fnOnComplete) { fnOnComplete(res.data.DTO); }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    };

    //=======================================
    // setGridColumns
    //=======================================
    // Sets the grid's columns based on the land uses in: this._allLandUses
    setGridColumns(){
        
        //column sizing
        let concernWidth = 15; //%
        let componentWidth = 15; //%

        //Add the static columns
        this._mainGridSettings.columns = [
            //{ fieldName: 'resource_concern_category_display', display: 'Category', width: '10%', minWidth: 30 },
            { fieldName: 'resource_concern_display', display: 'Resource Concern', width: concernWidth+'%', minWidth: 30 },
            { fieldName: 'resource_concern_component_display', display: 'Resource Concern Component', width: componentWidth+'%', minWidth: 30, sorted:'A' },
        ];

        let width = ((100 - (concernWidth + componentWidth)) / (this._allLandUses.length-1)) + "%";

        for (let i = 0; i < this._allLandUses.length; i++){

            let landUse = this._allLandUses[i];

            //I want to use the DTO point record here by ref, so I'm using the
            //procDataFn and editDataFn (which I just wrote :D) to override direct value updates.
            this._mainGridSettings.columns.push({ 
                fieldName: landUse.land_use_name, 
                display: landUse.land_use_display, 
                //editDataFn: (pointRecord, oldVal, newVal) => { pointRecord.practice_assessment_points = newVal ? +newVal : ""; pointRecord.changed = true; },
                procDataFn: (pointRecord) => { return pointRecord ? pointRecord.practice_assessment_points : "" },
                //tooTipFn: (pointRecord) => { return "Entry must be a numeric value between -999 and 999 or blank"},
                width: width, 
                minWidth: 20, 
                editable: false,
                numeric: true,
                min:-999,
                max:999
            });
        }

    }


    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // debugEntryClicked
    //=======================================
    debugEntryClicked(entry) {

        console.log("[{0}:debugEntryClicked]".format(this._componentName));
        console.log("    ", entry);

        switch (entry) {

            case "Dump Rows":
                console.log("Rows:", this._mainGridSettings.rows)
                break;

            case "Dump DTO":
                console.log("_pointsDTO", this._pointsDTO);
                break;

            case "Clear Sort":
                this.mainGrid.ClearSort();
                break;

        }
    };

};